<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
export default {
    name: 'App',
}
</script>

<style lang="less">
@import url(./asset/style/markdown.less);

body {
    margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue